
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-8",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","class":"w-8","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29 29"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 14.47l9.85-7.304a1.18 1.18 0 00-1.169-1.003H4.831a1.18 1.18 0 00-1.17 1.003l9.85 7.303a1.654 1.654 0 001.99 0z","fill":"#F96481"}}),_c('path',{attrs:{"d":"M15.5 14.47a1.69 1.69 0 01-1.989 0l-9.85-7.304c-.012.058-.036.105-.036.163v14.047c0 .641.543 1.166 1.206 1.166h19.338c.663 0 1.206-.525 1.206-1.166V7.318c0-.059-.024-.105-.036-.164L15.5 14.47z","fill":"#E95843"}}),_c('path',{attrs:{"d":"M15.5 14.47l9.85-7.304a1.18 1.18 0 00-1.169-1.003H4.831a1.18 1.18 0 00-1.17 1.003l9.85 7.303a1.654 1.654 0 001.99 0z","fill":"#F6CFC9"}})])
          )
        }
      }
    